var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScenariosOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2873_6434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.625 6H23.625C23.8902 6 24.1446 5.89464 24.3321 5.70711C24.5196 5.51957 24.625 5.26522 24.625 5C24.625 4.73478 24.5196 4.48043 24.3321 4.29289C24.1446 4.10536 23.8902 4 23.625 4H7.625C7.35978 4 7.10543 4.10536 6.91789 4.29289C6.73036 4.48043 6.625 4.73478 6.625 5C6.625 5.26522 6.73036 5.51957 6.91789 5.70711C7.10543 5.89464 7.35978 6 7.625 6Z",
    fill: "#212538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.625 11H7.625C7.35978 11 7.10543 11.1054 6.91789 11.2929C6.73036 11.4804 6.625 11.7348 6.625 12C6.625 12.2652 6.73036 12.5196 6.91789 12.7071C7.10543 12.8946 7.35978 13 7.625 13H23.625C23.8902 13 24.1446 12.8946 24.3321 12.7071C24.5196 12.5196 24.625 12.2652 24.625 12C24.625 11.7348 24.5196 11.4804 24.3321 11.2929C24.1446 11.1054 23.8902 11 23.625 11Z",
    fill: "#212538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.625 18H7.625C7.35978 18 7.10543 18.1054 6.91789 18.2929C6.73036 18.4804 6.625 18.7348 6.625 19C6.625 19.2652 6.73036 19.5196 6.91789 19.7071C7.10543 19.8946 7.35978 20 7.625 20H23.625C23.8902 20 24.1446 19.8946 24.3321 19.7071C24.5196 19.5196 24.625 19.2652 24.625 19C24.625 18.7348 24.5196 18.4804 24.3321 18.2929C24.1446 18.1054 23.8902 18 23.625 18Z",
    fill: "#212538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 7C3.72957 7 4.625 6.10457 4.625 5C4.625 3.89543 3.72957 3 2.625 3C1.52043 3 0.625 3.89543 0.625 5C0.625 6.10457 1.52043 7 2.625 7Z",
    fill: "#212538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 14C3.72957 14 4.625 13.1046 4.625 12C4.625 10.8954 3.72957 10 2.625 10C1.52043 10 0.625 10.8954 0.625 12C0.625 13.1046 1.52043 14 2.625 14Z",
    fill: "#212538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 21C3.72957 21 4.625 20.1046 4.625 19C4.625 17.8954 3.72957 17 2.625 17C1.52043 17 0.625 17.8954 0.625 19C0.625 20.1046 1.52043 21 2.625 21Z",
    fill: "#212538"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2873_6434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenariosOff);
export default __webpack_public_path__ + "static/media/scenariosOff.607e27a2cf3dfcacf220c41bb6c53741.svg";
export { ForwardRef as ReactComponent };